import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const styles = () => ({
  root: {
    padding: '55px 20px',
  },
  copy: {
    color: '#58657C',
  },
});

const GlobalFooter = ({ classes }) => (
  <div className={classes.root}>
    <div className="container">
      <Typography align="center" className={classes.copy}>
        Powered by{' '}
        <a href="https://www.sellonlive.tech/" target="_blank" title="SellOnLive" rel="noreferrer">
          <img src="/static/images/footerLogo.svg" />
        </a>
      </Typography>
    </div>
  </div>
);

GlobalFooter.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GlobalFooter);
